import { render, staticRenderFns } from "./FlowError.vue?vue&type=template&id=b1640b20&scoped=true&"
import script from "./FlowError.vue?vue&type=script&lang=js&"
export * from "./FlowError.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1640b20",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/app/bamboo/xml-data/build-dir/WWW-WWW-JOB1/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('b1640b20')) {
      api.createRecord('b1640b20', component.options)
    } else {
      api.reload('b1640b20', component.options)
    }
    module.hot.accept("./FlowError.vue?vue&type=template&id=b1640b20&scoped=true&", function () {
      api.rerender('b1640b20', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "app/src/components/generic/FlowError.vue"
export default component.exports